export default "__VITE_ASSET__kpERy$yII1_yJxl2jSpzDA__"